import { PageHeader } from '@components/primitives/Layout/HeaderComponents/PageHeader'
import DynamicRoutes from '@lib/routes/DynamicRoutes'
import ExternalRoutes from '@lib/routes/ExternalRoutes'
import absoluteUrl from '@lib/routes/helpers/absoluteUrl'
import getCanonicalUrl from '@lib/routes/helpers/getCanonicalUrl'
import { isModuleCondition } from '@modules/conditions/helpers/isAuthoritativeCondition'
import { getPhaseFromPhaseList } from '@modules/trials/helpers/getPhaseFromPhaseList'
import type { TrialAssociation } from '@modules/trials/types/TrialAssociation'

export const TrialListingHeader = ({
  trial,
  trialTitle,
}: {
  trial: TrialAssociation
  trialTitle: string
}) => {
  const conditionsList = trial.conditions
    .filter(isModuleCondition)
    .map((condition) => condition.condition.name)
    .join(', ')
  const treatmentsList = trial.interventions
    .map((intervention) => intervention.name)
    .join(', ')
  const phasePhrase = getPhaseFromPhaseList(trial.phaseList)
  const applyPhrase = `Apply to this${
    phasePhrase === 'N/A' ? '' : ` ${phasePhrase}`
  } clinical trial treating ${conditionsList}`
  const metaDescription = `${applyPhrase}. Get access to cutting edge treatment via ${treatmentsList}. View duration, location, compensation, and staffing details.`
  // Prefer our canonical URLs to be all lowercase and without any GET parameters
  const canonicalUrl = getCanonicalUrl(
    absoluteUrl(DynamicRoutes.trial(trial.slug!)),
  )

  const ogImgUrl = ExternalRoutes.merianOgImage({
    text: `${applyPhrase}: ${trialTitle}`,
  })

  return (
    <PageHeader
      canonicalUrl={canonicalUrl}
      metaDescription={metaDescription}
      openGraphTitle={trialTitle}
      openGraphUrl={ogImgUrl}
      pageTitle={`${trialTitle} Clinical Trial ${new Date().getFullYear()}`}
    />
  )
}
